import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useSelector } from 'react-redux';
import { getRawClubData, getSearchValue } from '../../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { ClubNameCell } from './academyTableComponent';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import './ExplorePage.css'; // Import the CSS file

const ClubTableComponent: React.FC = ({ setRowCount }:any) => {
  const rows = useSelector(getRawClubData);
  const searchValue = useSelector(getSearchValue);
  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(false);
  const [isAscending2, setIsAscending2] = useState(false);
  const [isAscending3, setIsAscending3] = useState(false);
  const [isAscending4, setIsAscending4] = useState(false);
  const [isAscending5, setIsAscending5] = useState(false);

  const [objectList, setObjectList] = useState(rows);
  const [t] = useTranslation();

  const handleSortClick = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const nameA = a.club.name.toLowerCase();
      const nameB = b.club.name.toLowerCase();

      if (isAscending) {
        return nameA?.localeCompare(nameB);
      } else {
        return nameB?.localeCompare(nameA);
      }
    });

    setObjectList(sortedList);
    setIsAscending(!isAscending);
  };

  const handleSortClick1 = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const nameA = a?.type?.toLowerCase() === 'total' ? 'Club Total' : 'Academy ' + a.type;
      const nameB = b?.type?.toLowerCase() === 'total' ? 'Club Total' : 'Academy ' + b.type;

      if (isAscending1) {
        return nameA?.localeCompare(nameB);
      } else {
        return nameB?.localeCompare(nameA);
      }
    });

    setObjectList(sortedList);
    setIsAscending1(!isAscending1);
  };

  const handleSortClick2 = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const nameA = a?.name;
      const nameB = b?.name;

      if (isAscending2) {
        return nameA?.localeCompare(nameB);
      } else {
        return nameB?.localeCompare(nameA);
      }
    });

    setObjectList(sortedList);
    setIsAscending2(!isAscending2);
  };

  const handleSortClick3 = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const nameA = a?.otherExpenseName;
      const nameB = b?.otherExpenseName;

      if (isAscending3) {
        return nameA?.localeCompare(nameB);
      } else {
        return nameB?.localeCompare(nameA);
      }
    });

    setObjectList(sortedList);
    setIsAscending3(!isAscending3);
  };

  const handleSortClick4 = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const numberA = a?.currentYear;
      const numberB = b?.currentYear;

      if (isAscending4) {
        return numberA - numberB;
      } else {
        return numberB - numberA;
      }
    });

    setObjectList(sortedList);
    setIsAscending4(!isAscending4);
  };

  const handleSortClick5 = () => {
    const sortedList = [...objectList].sort((a, b) => {
      const numberA = a?.nextYear;
      const numberB = b?.nextYear;

      if (isAscending5) {
        return numberA - numberB;
      } else {
        return numberB - numberA;
      }
    });

    setObjectList(sortedList);
    setIsAscending5(!isAscending5);
  };

  const labelPicker = (label: string) => {
    switch (label) {
      case 'Income':
        return 'DC_3_INCOME';
      case 'Expense':
        return 'DC_3_EXPENSE';

      case 'Membership fee income':
        return 'DC_3_MEMBERSHIP_FEE_INCOME';
      case 'J League Support Fund':
        return 'DC_3_J_LEAGUE_SUPPORT_FUND';

      case 'Travel':
        return 'DC_3_TRAVEL';
      case 'Facilities':
        return 'DC_3_FACILITIES';
      case 'Equipment/Fixtures':
        return 'DC_3_EQUIPMENT_FIXTURES';
      case 'Labour Cost':
        return 'DC_3_LABOUR_COST';
      case 'Other':
        return 'DC_3_OTHER';

      case 'U12/Development Centre':
        return 'DC_3_DEV_CENTRE';
      case 'U15s':
        return 'DC_3_U15S';
      case 'U18s':
        return 'DC_3_U18S';
      case 'Soccer School':
        return 'DC_3_SOCCER_SCHOOL';
      case 'Club Total':
        return 'DC_3_CLUB_TOTAL';
      case 'Academy Expense':
        return 'ACADEMY_EXPENSE';
      case 'Academy Income':
        return 'ACADEMY_INCOME';
      default:
        return label;
    }
  };

  useEffect(() => {
    if (searchValue != '') {
      const filteredList = rows.filter((item:any) => {
        const lowerCaseSearchValue = searchValue.toLowerCase();

        return (
          item.club.name.toLowerCase().includes(lowerCaseSearchValue) ||
          item.name.toLowerCase().includes(lowerCaseSearchValue) ||
          item.otherExpenseName.toLowerCase().includes(lowerCaseSearchValue) ||
          (item?.type?.toLowerCase() === 'total' && 'Club Total'.toLowerCase().includes(lowerCaseSearchValue)) ||
          ('Academy ' + item.type).toLowerCase().includes(lowerCaseSearchValue)
        );
      });
      setObjectList(filteredList);
      setRowCount(filteredList.length);
    } else {
      setObjectList(rows);
      setRowCount(rows.length);
    }
  }, [searchValue, rows]);

  const rowsSkeleton = Array.from({ length: 10 }).map((_, index) => (
    <TableRow key={index}>
      {Array.from({ length: 6 }).map((_, cellIndex) => (
        <TableCell key={cellIndex}>
          <Skeleton variant="text" sx={{ fontSize: '1rem' }} width="100%" height={20} />
        </TableCell>
      ))}
    </TableRow>
  ));

  return (
    <TableContainer sx={{ maxHeight: '600px', overflow: 'auto' }}>
      <Table sx={{ width: 'max-content' }} stickyHeader aria-label="sticky table">
        <TableRow className="sticky-header">
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }}>
            {t('DC_5_CLUB').toUpperCase()}
            {isAscending ? (
              <ArrowDropUpIcon onClick={handleSortClick} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick} />
            )}
          </TableCell>
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }}>
            {t('CATEGORY').toUpperCase()}
            {isAscending1 ? (
              <ArrowDropUpIcon onClick={handleSortClick1} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick1} />
            )}
          </TableCell>
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }}>
            {t('DC_3_LINE_ITEM').toUpperCase()}
            {isAscending2 ? (
              <ArrowDropUpIcon onClick={handleSortClick2} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick2} />
            )}
          </TableCell>
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }}>
            {t('DC_3_SUB_LINE_ITEM').toUpperCase()}
            {isAscending3 ? (
              <ArrowDropUpIcon onClick={handleSortClick3} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick3} />
            )}
          </TableCell>
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }} align="right">
            {t('ACTUAL(¥)').toUpperCase()}
            {isAscending4 ? (
              <ArrowDropUpIcon onClick={handleSortClick4} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick4} />
            )}
          </TableCell>
          <TableCell style={{ fontWeight: 'bold', fontFamily: 'Montserrat', padding: '5px 16px' }} align="right">
            {t('DC_3_BUDGET').toUpperCase()}
            {isAscending5 ? (
              <ArrowDropUpIcon onClick={handleSortClick5} />
            ) : (
              <ArrowDropDownIcon onClick={handleSortClick5} />
            )}
          </TableCell>
          <TableCell style={{ padding: '5px 16px' }}></TableCell>
        </TableRow>
        <TableBody>
          {rows && rows.length > 0 ? (
            objectList?.length > 0 ? (
              objectList.map((row:any, index:any) => (
                <TableRow hover key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row" style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '375px' }}>
                    <ClubNameCell clubData={row} />
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '375px' }}>
                    {row?.type?.toLowerCase() === 'total'
                      ? t(labelPicker('Club Total'))
                      : row?.type == t('ACADEMY_TOTAL')
                      ? row?.type
                      : t(labelPicker('Academy ' + row?.type))}
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '375px' }}>
                    {t(labelPicker(row?.name))}
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '300px' }}>
                    {t(labelPicker(row?.otherExpenseName))}
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '150px' }} align="right">
                    {row?.currentYear?.toLocaleString()}
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', minWidth: '100px', maxWidth: '150px' }} align="right">
                    {row?.nextYear?.toLocaleString()}
                  </TableCell>
                  <TableCell style={{ fontFamily: 'Montserrat', padding: '0px 16px', width: '370px' }}></TableCell>
                </TableRow>
              ))
            ) : searchValue === '' ? (
              rowsSkeleton
            ) : (
              <TableRow>
                <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                  {t('No_Matching_Records_Found')}...
                </TableCell>
              </TableRow>
            )
          ) : objectList?.length == 0 ? (
            <TableRow>
              <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                {t('No_Matching_Records_Found')}...
              </TableCell>
            </TableRow>
          ) : (
            rowsSkeleton
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ClubTableComponent;
